import { initSplideCarousel } from '@/splide-carousel';
import { revealOnScroll, motionTokens } from '@/motion-primitives';

/** Splide easing aligned with the project's "warm" curve (ease-out-quart). */
const RMH_SPLIDE_EASING = `cubic-bezier(${motionTokens.easeOut.join(',')})`;

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-story-quote').forEach((block) => {
		initSplideCarousel(block, {
			type: 'fade',
			speed: 600,
			easing: RMH_SPLIDE_EASING,
		});

		const wrapper = block.querySelector('.js-story-quote-wrapper') || block;
		revealOnScroll(wrapper, {
			duration: motionTokens.durLg,
			distance: 16,
		});
	});
});
